// client/src/pages/clientPortal/PortalLoginPage.js
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useClientPortalAuth } from '../../hooks/useClientPortalAuth';
import { usePortalPwa } from '../../components/clientPortal/PwaSupport';

const PortalLoginPage = () => {
    usePortalPwa();
    const { login, error, loading } = useClientPortalAuth();
    const [loginEmail, setLoginEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await login(loginEmail, password);
        if (result) {
            navigate(result.mustChangePassword ? '/client-portal/change-password'
                : (result.accountKind === 'visitor' ? '/client-portal/my-properties' : '/client-portal/dashboard'));
        }
    };

    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white p-8 rounded-lg shadow">
                <h1 className="text-2xl font-bold text-slate-800 mb-6 text-center">Client Portal Login</h1>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        type="email"
                        value={loginEmail}
                        onChange={(e) => setLoginEmail(e.target.value)}
                        placeholder="Email"
                        required
                        className="w-full p-3 border rounded-md"
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        required
                        className="w-full p-3 border rounded-md"
                    />
                    {error && <p className="text-red-500 text-sm">{error}</p>}
                    <button type="submit" disabled={loading} className="w-full px-4 py-3 text-white bg-slate-800 rounded-md hover:bg-slate-900 disabled:bg-indigo-400">
                        {loading ? 'Logging in...' : 'Log In'}
                    </button>
                </form>
                <p className="mt-4 text-center text-sm text-slate-700">
                    New here? <Link to="/client-portal/register" className="font-semibold text-indigo-800 underline">Create a free account</Link> to save property searches and favourites.
                </p>
            </div>
        </div>
    );
};

export default PortalLoginPage;
